<template>
  <div class="app">
    <AppHeader class="header"></AppHeader>
    <router-view class="body"></router-view>
  </div>
</template>

<script>
import AppHeader from 'components/Header.vue'

export default {
  components: {AppHeader},
}
</script>

<style lang="scss">
@import "src/scss/var/colors";
@import "src/scss/var/app";

$padding: $page-padding;

.app {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.header {
  color: $color-primary;
  display: flex;
  align-items: stretch;
  background: white;
  box-shadow: 0 1px 5px -2px $color-border;
  margin-bottom: 1px;
  > div {
    display: flex;
    align-items: center;
  }
  .brand {
    font-size: 1.5rem;
    padding: 6px $padding;
    font-weight: bold;
    width: $nav-width;
  }
  .menu {
    flex: 1;
    font-size: 1.2rem;
    align-items: stretch;
  }
  .brand, .menu {
    a {
      text-decoration: none;
      text-align: center;
      min-width: 6em;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $color-normal;
      &:hover {
        color: mix($color-primary, #fff, 90%);
        font-weight: bold;
        text-shadow: 1px 1px 5px -2px $color-border;
      }
      &.router-link-active {
        background-color: $color-menu-background;
        color: $color-primary;
        font-weight: bold;
        text-shadow: none;
      }
    }
  }
  .username {
    padding: 0 $padding;
    .el-dropdown {
      cursor: pointer;
    }
    .username-text {
      padding-right: 1.2em;
      display: inline-block;
      min-width: 4em;
      text-align: right;
      color: $color-normal;
    }
    .logout {
      user-select: none;
      cursor: pointer;
      color: $color-normal;
      &:hover {
        color: $color-danger;
      }
    }
  }
}

.body {
  flex: 1;
  &.page-nav-container, .page-nav-container {
    display: flex;
    .page-content {
      flex: 1;
    }
  }
  &.page-nav, .page-nav {
    width: $nav-width;
    background-color: $color-block-background;
    height: 100%;
    overflow: auto;
    margin: 0;
    box-shadow: 1px 0 5px -2px $color-border;
    > .el-menu-item, > .el-submenu {
      &:first-child {
        margin-top: $padding;
      }
      &:last-child {
        margin-bottom: $padding;
      }
    }
    .el-menu-item, .el-submenu__title {
      height: 40px;
      line-height: 40px;
      padding: 0 !important;
      .fa-icon {
        color: $color-grey;
        width: 1.2em;
      }
    }
    li {
      list-style: none;
      margin: 2px 0;
      a {
        text-decoration: none;
        color: $color-normal;
        padding: 0 20px;
        display: block;
        cursor: pointer;
        &:hover {
          .fa-icon {
            color: $color-primary;
          }
        }
      }
      &.coming-soon a, a.coming-soon {
        color: mix($color-normal, white, 50%);
        .fa-icon {
          color: mix($color-grey, white, 50%);
        }
      }
      &.el-menu-item.is-active > a {
        .fa-icon {
          color: $color-primary;
        }
        background-color: mix($color-success, white, 10%);
      }
      ul {
        background-color: mix($color-block-background, black, 96%);
      }
      li a {
        padding: 0 20px 0 30px;
      }
      li li a {
        padding: 0 20px 0 40px;
      }
    }
  }
  &.page-content, .page-content {
    padding: $padding;
    height: 100%;
    overflow: auto;
  }
}

.footer {
  text-align: center;
  font-size: 0.8rem;
  color: $color-grey;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.username-dropdown-menu {
  min-width: 150px;
}

</style>



// WEBPACK FOOTER //
// src/components/App.vue